"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = exports.SimulationComponent = exports.SimulationViewStore = undefined;

var _defineProperty = require("babel-runtime/core-js/object/define-property");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = require("babel-runtime/core-js/object/get-own-property-descriptor");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class, _descriptor, _dec2, _class3, _class4, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = require("mobx");

var _mobxReact = require("mobx-react");

var _autoclassDecorator = require("autoclass-decorator");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseComponent = require("base-component");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _baseViewstore = require("base-viewstore");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _simgateDatamodel = require("simgate-datamodel");

var _simgateDatamodel2 = _interopRequireDefault(_simgateDatamodel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var SimulationViewStore = exports.SimulationViewStore = (_dec = _mobx.observable.ref, (_class = function (_BaseViewStore) {
  (0, _inherits3.default)(SimulationViewStore, _BaseViewStore);

  function SimulationViewStore() {
    (0, _classCallCheck3.default)(this, SimulationViewStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SimulationViewStore.__proto__ || (0, _getPrototypeOf2.default)(SimulationViewStore)).apply(this, arguments));

    _this.dispose = [];

    _initDefineProp(_this, "dataModel", _descriptor, _this);

    var _this$props = _this.props,
        _this$props$dataModel = _this$props.dataModel,
        projectDomainStore = _this$props$dataModel.domainStore,
        _this$props$dataModel2 = _this$props$dataModel.domainStore,
        simgate = _this$props$dataModel2.simgate,
        parentPathId = _this$props$dataModel2.context.simParentPathId,
        simulation = _this$props.contentModel,
        application = _this$props.application;


    if (!application) throw new Error("no application!");
    if (!simgate) throw new Error("no simgate!");
    if (!parentPathId) throw new Error("no parentPathId!");

    //get existing dataModel for this sim if it exists, otherwise create
    if (application.simDataModels[simulation.id]) {
      _this.simDataModel = application.simDataModels[simulation.id];
    } else {
      _this.simDataModel = application.simDataModels[simulation.id] = new _simgateDatamodel2.default({
        simgate: simgate
      });
    }

    // add sim domain store if it doesnt exist
    if (!_this.simDataModel.domainStore) {
      _this.simDataModel.addStore(simulation.SimDomainStore, {
        simgate: simgate,
        projectDomainStore: projectDomainStore,
        simulation: simulation,
        parentPathId: parentPathId,
        contentModel: _this // we can link this in, because we know there is a 1:1 relationship between sim store and sim content model.  this differs from activities because activities may have an unknown hierarchy of submodels etc, and we dont know which may be driving input values at any given time
      });
    }
    _this.simDomainStore = _this.simDataModel.domainStore;

    _this.dispose.push((0, _mobx.reaction)(function () {
      return _this.simDomainStore.isLoaded && !!_this.currentTeamState;
    }, function (ready) {
      if (!ready) return;
      _this.currentTeamState.tasks.forEach(function (task) {
        task.activity.$inputStore = _this.simDataModel[task.id] || _this.simDataModel.addStore(task.activity.InputStore || task.InputStore);
      });
    }));

    if (simulation.shell && simulation.shell.autoAdvanceTeams) {
      _this.dispose.push((0, _mobx.autorun)(function () {
        return _this.allComplete && _this.simDomainStore.completeTask();
      }));
    }
    return _this;
  }

  (0, _createClass3.default)(SimulationViewStore, [{
    key: "currentRoundTeamStates",
    get: function get() {
      var simulation = this.props.contentModel;


      var round = simulation.rounds[this.simDomainStore.currentRoundNo ? this.simDomainStore.currentRoundNo - 1 : 0];
      return round.teamStates;
    }
  }, {
    key: "currentTeamState",
    get: function get() {
      var _this2 = this;

      var ts = this.currentRoundTeamStates.find(function (ts) {
        return ts.id === _this2.simDomainStore.teamStateName;
      });
      if (ts && !ts.tasks.length) debugger;
      return this.currentRoundTeamStates.find(function (ts) {
        return ts.id === _this2.simDomainStore.teamStateName;
      });
    }
  }, {
    key: "allComplete",
    get: function get() {
      return this.currentTeamState && this.currentTeamState.tasks.every(function (task) {
        if (!task.required) return true;
        return task.isCompleted;
      });
    }
  }]);
  return SimulationViewStore;
}(_baseViewstore2.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "dataModel", [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "currentRoundTeamStates", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "currentRoundTeamStates"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentTeamState", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "currentTeamState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allComplete", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "allComplete"), _class.prototype)), _class));
var SimulationComponent = exports.SimulationComponent = (_dec2 = (0, _mobxReact.inject)("dataModel", "application"), _dec2(_class3 = (0, _mobxReact.observer)(_class3 = (0, _autoclassDecorator2.default)(_class3 = (_temp = _class4 = function (_BaseComponent) {
  (0, _inherits3.default)(SimulationComponent, _BaseComponent);

  function SimulationComponent() {
    (0, _classCallCheck3.default)(this, SimulationComponent);
    return (0, _possibleConstructorReturn3.default)(this, (SimulationComponent.__proto__ || (0, _getPrototypeOf2.default)(SimulationComponent)).apply(this, arguments));
  }

  (0, _createClass3.default)(SimulationComponent, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          _props$dataModel = _props.dataModel,
          projectDomainStore = _props$dataModel.domainStore,
          _props$dataModel$doma = _props$dataModel.domainStore,
          simgate = _props$dataModel$doma.simgate,
          parentPathId = _props$dataModel$doma.context.simParentPathId,
          simulation = _props.contentModel,
          application = _props.application;
      var simDataModel = this.viewStore.simDataModel;


      var Shell = simulation.shell && simulation.shell.Component;

      return !!Shell && _react2.default.createElement(
        _mobxReact.Provider,
        { inputStore: this.simDomainStore, dataModel: simDataModel },
        _react2.default.createElement(Shell, {
          inputStore: this.simDomainStore,
          dataModel: simDataModel,
          contentModel: simulation.shell,
          simulation: simulation,
          projectDomainStore: projectDomainStore,
          parentPathId: parentPathId
        })
      );
    }
  }]);
  return SimulationComponent;
}(_baseComponent2.default), _class4.ViewStore = SimulationViewStore, _temp)) || _class3) || _class3) || _class3);
var Component = exports.Component = SimulationComponent;
var _default = Component;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SimulationViewStore, "SimulationViewStore", "src/entity_modules/simulation-entity/component.js");

  __REACT_HOT_LOADER__.register(SimulationComponent, "SimulationComponent", "src/entity_modules/simulation-entity/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "src/entity_modules/simulation-entity/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "src/entity_modules/simulation-entity/component.js");
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/entity_modules/simulation-entity/component.js
// module id = ./node_modules/platform-client-bootstrap/dist/entity_modules/simulation-entity/component.js
// module chunks = 0